/**
 * Generated runtime TestId mirror for frontend/src/pages/SystemDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SystemDetailTestIds = {
  btnAddConnector: "btn-add-connector",
  btnDeleteSystem: "btn-delete-system",
  cardSystemDetails: "card-system-details",
  cardTitleConnector: "card-title-connector",
  colClassification: "col-classification",
  colEoName: "col-eo-name",
  colEoResource: "col-eo-resource",
  colEoType: "col-eo-type",
  colName: "col-name",
  colType: "col-type",
  connectorCapabilityBanner: "connector-capability-banner",
  linkConnectorDetail: "link-connector-detail",
  sectionAttributes: "section-attributes",
  sectionEnforcementObjects: "section-enforcement-objects",
  sectionResources: "section-resources",
  systemDetailPage: "system-detail-page",
  terminationActionLabel: "termination-action-label",
  linkEnforcementObject: (eo_id: string) => `link-enforcement-object-${eo_id}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkEnforcementObjectResource: (eo_id: string) => `link-enforcement-object-resource-${eo_id}`,
  linkEnforcementObjectResourcePrefix: () => "link-enforcement-object-resource-" as TestIdPrefix,
  linkResourceDetail: (resource_id: string) => `link-resource-detail-${resource_id}`,
  linkResourceDetailPrefix: () => "link-resource-detail-" as TestIdPrefix
} as const;
